/**
 * Interviews of volunteer applicants (owner request 2026-11-01): the administration opens times, sends each
 * applicant a personal booking link (three days), and meets them by audio in a personal room link.
 */
import { z } from "zod";
/** The applicant's personal link token travels in this header (read from the URL fragment). */
export const INTERVIEW_TOKEN_HEADER = "x-interview-token";
/** How long a booking link works. */
export const INTERVIEW_BOOK_DAYS = 3;
/** The applicant may cancel up to this many hours before (once; then they book again). */
export const INTERVIEW_CANCEL_HOURS = 2;
/** The room opens this many minutes before the time. */
export const INTERVIEW_OPENS_MINUTES = 10;
/** In messages: replaced by each applicant's name, their link, and the last day the link works. */
export const INTERVIEW_PLACEHOLDERS = { name: "{الاسم}", link: "{الرابط}", until: "{آخر موعد}" };
export const InterviewStatus = z.enum(["invited", "booked", "cancelled", "finished", "missed"]);
const Day = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const Clock = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
export const CreateInterviewSlotsBody = z
    .object({
    organizationId: z.uuid(),
    days: z.array(Day).min(1).max(31),
    from: Clock,
    to: Clock,
    minutes: z.number().int().min(5).max(120),
    capacity: z.number().int().min(1).max(10),
})
    .refine((b) => b.from < b.to, { message: "وقت النهاية بعد البداية", path: ["to"] });
export const CreateInterviewSlotsResponse = z.object({ created: z.number(), skipped: z.number() });
export const InterviewSlotsQuery = z.object({ organizationId: z.uuid(), from: Day, to: Day });
export const InterviewSlot = z.object({
    id: z.uuid(),
    startsAt: z.string(),
    minutes: z.number(),
    capacity: z.number(),
    booked: z.array(z.object({ interviewId: z.uuid(), name: z.string() })),
});
export const InterviewSlotsResponse = z.object({ timezone: z.string(), slots: z.array(InterviewSlot) });
export const InviteInterviewsBody = z.object({
    ids: z.array(z.uuid()).min(1).max(100),
    body: z
        .string()
        .trim()
        .min(1)
        .max(2000)
        .refine((b) => b.includes(INTERVIEW_PLACEHOLDERS.link), { message: "ضع {الرابط} في الرسالة" }),
});
export const InviteInterviewsResponse = z.object({
    results: z.array(z.object({ id: z.uuid(), ok: z.boolean(), error: z.string().nullable() })),
});
export const InterviewHallQuery = z.object({ organizationId: z.uuid(), day: Day });
export const InterviewHallItem = z.object({
    id: z.uuid(),
    applicationId: z.uuid(),
    name: z.string(),
    phone: z.string(),
    gender: z.enum(["male", "female"]),
    nationality: z.string(),
    juz: z.number(),
    fromSurah: z.number(),
    toSurah: z.number(),
    hasIjazah: z.boolean(),
    times: z.array(z.string()),
    timesOther: z.string().nullable(),
    experience: z.string().nullable(),
    hasCv: z.boolean(),
    cvUrl: z.string().nullable(),
    applicationStatus: z.enum(["new", "interview", "accepted", "rejected"]),
    status: InterviewStatus,
    startsAt: z.string(),
    minutes: z.number(),
    /** The applicant has the room open now. */
    waiting: z.boolean(),
    connectedAt: z.string().nullable(),
    endedAt: z.string().nullable(),
});
export const InterviewHallResponse = z.object({
    timezone: z.string(),
    interviews: z.array(InterviewHallItem),
});
export const EndInterviewBody = z.object({ outcome: z.enum(["finished", "missed", "cancelled"]) });
export const InterviewRemindResponse = z.object({ ok: z.boolean(), error: z.string().nullable() });
// ------------------------------------------------------------------ the applicant's pages (no account)
export const InterviewBookingResponse = z.object({
    name: z.string(),
    bookBy: z.string(),
    timezone: z.string(),
    slots: z.array(z.object({ id: z.uuid(), startsAt: z.string(), minutes: z.number(), available: z.boolean() })),
});
export const BookInterviewBody = z.object({ slotId: z.uuid() });
export const BookInterviewResponse = z.object({ roomToken: z.string() });
export const InterviewRoomResponse = z.object({
    interviewId: z.uuid(),
    name: z.string(),
    timezone: z.string(),
    status: InterviewStatus,
    startsAt: z.string().nullable(),
    minutes: z.number().nullable(),
    /** From when to when the call can be joined. */
    opensAt: z.string().nullable(),
    closesAt: z.string().nullable(),
    canCancel: z.boolean(),
    canRebook: z.boolean(),
});
export const CancelInterviewResponse = z.object({ bookingToken: z.string().nullable() });
//# sourceMappingURL=interviews.js.map